import { render } from "./add.vue?vue&type=template&id=673ab88c&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=673ab88c&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673ab88c"],['__file',"resources/js/pages/notes/add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "673ab88c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('673ab88c', __exports__)) {
    console.log('reload')
    api.reload('673ab88c', __exports__)
  }
  
  module.hot.accept("./add.vue?vue&type=template&id=673ab88c&scoped=true", () => {
    console.log('re-render')
    api.rerender('673ab88c', render)
  })

}


export default __exports__